module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/view/branch-details/branch-grid/branch-grid.component.css
// module id = ./src/app/pages/view/branch-details/branch-grid/branch-grid.component.css
// module chunks = main